module.exports = __webpack_public_path__ + "img/49ne.d91cf80b.svg";